<div *ngIf="isOpenPopup" class="bg-popup  animate__fadeIn animate__animated animate__faster">
    <div class="popup animate__animated animate__slideInUp animate__faster">
        <h3 *ngIf="typePopup=='confirmation'; else rechazarTitle" class="title">Confirmar Solicitud</h3>
        <ng-template #rechazarTitle>
            <h3  class="title" >Rechazar Solicitud</h3>
        </ng-template>
        
        <button id="closeDetails" (click)="closePopup()"></button>
        <svg *ngIf="isLoading" id="loadbar" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="24px" height="24px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
          <g transform="translate(50,50)">
            <g transform="scale(0.7)">
            <circle cx="0" cy="0" r="50" fill="#2ecc71"></circle>
            <circle cx="0" cy="-28" r="15" fill="#ffffff">
              <animateTransform attributeName="transform" type="rotate" dur="1s" repeatCount="indefinite" keyTimes="0;1" values="0 0 0;360 0 0"></animateTransform>
            </circle>
            </g>
          </g>
          <!-- [ldio] generated by https://loading.io/ --></svg>
        <div *ngIf="typePopup=='confirmation'; else rechazarBody" class="popup-body">
            <i class="fa fa-check-circle" aria-hidden="true"></i>
            <p>Quiere confirmar la solicitud de matrícula de <span class="name">{{formatFullName(selectedStudent.name+' '+selectedStudent.lastname)}}</span></p>
            <p>Se enviará una notificación a este correo:<br><span class="email">{{selectedStudent.email}}</span></p>
            <p><i class="fa fa-paperclip" aria-hidden="true"></i>Adjuntar hoja de matrícula de CLASS</p>
            <div class="dropzone" appDragndrop (fileDropped)="onFileDropped($event)">
                <input type="file" #fileDropRef id="fileDropRef" (change)="fileBrowseHandler($event.target.files)">
                <div class="drag-options">
                    <h3>Arrastre y suelte o </h3>
                    <label for="fileDropRef">busque un archivo</label>
                </div>
            </div>
            <div class="list-doc"  *ngFor="let file of files">
                <i class="fa fa-file-text-o" aria-hidden="true"></i>
                <h3>{{file.name}}</h3>
                <button class="deleteFile" (click)="deleteAllFile()"></button>
            </div>
        </div>
        <ng-template #rechazarBody>
            <div class="popup-body">
                <i [ngStyle]="{'color':'#f39c12'}" class="fa fa-frown-o" aria-hidden="true"></i>
                <p>La solicitud de <span class="name">{{formatFullName(selectedStudent.name+' '+selectedStudent.lastname)}}</span> se rechaza por:</p>
                <div class="radio-content">
                    <label for="opt1" class="radio">
                        <input
                        name="rdo"
                          type="radio"
                          id="opt1"
                          class="hidden"
                          value="Documentos incompletos"
                          (change)="onChangeReject($event.target.value)"
                        />
                        <span class="label"></span>Documentos incompletos<br />
                      </label>
                      <label for="opt2" class="radio">
                        <input
                        name="rdo"
                          type="radio"
                          id="opt2"
                          class="hidden"
                          value="No hubo contacto por teléfono o correo"
                          (change)="onChangeReject($event.target.value)"/>
                        <span class="label"></span>No hubo contacto por teléfono o correo<br />
                      </label>
                      <label for="opt3" class="radio">
                        <input
                        name="rdo"
                          type="radio"
                          id="opt3"
                          class="hidden"
                          value="Solicitud duplicada"
                          (change)="onChangeReject($event.target.value)"/>
                        <span class="label"></span>Solicitud duplicada<br />
                      </label>
                      <label for="opt4" class="radio">
                        <input
                        name="rdo"
                          type="radio"
                          id="opt4"
                          class="hidden"
                          value="No se recibio el pago de la matrícula"
                          (change)="onChangeReject($event.target.value)"/>
                        <span class="label"></span>No se recibio el pago de la matrícul.<br />
                      </label>
                      <label for="opt5" class="radio">
                        <input
                        name="rdo"
                          type="radio"
                          id="opt5"
                          class="hidden"
                          value="Otro"
                          (change)="onChangeReject($event.target.value)"/>
                        <span class="label"></span>Otro<br />
                      </label>
                      <textarea #otherValue id="otherValue" [disabled]="!isOtherValue" cols="30" rows="4"></textarea>

                </div>
                
            </div>
        </ng-template>
       
        <div class="popup-actions" *ngIf="typePopup=='confirmation'; else rechazarActions">
            <button id="btnCancelPopup" (click)="closePopup()">Cancelar</button>
            <button id="btnConfirmPopup" (click)="sendConfirmationEmail()" [disabled]="isLoading" >Confimar</button>
        </div>
        <ng-template #rechazarActions>
            <div class="popup-actions">
                <button id="btnCancelPopup" (click)="closePopup()">Cancelar</button>
                <button id="btnConfirmPopup" (click)="rejectStudent()" [disabled]="isLoading" >Aceptar</button>
            </div>
        </ng-template>
       
       
    </div>
</div>
